<template>
  <b-container
    fluid
    class="bg-white shadow-inset-top"
    style="min-height: calc(100vh - 95px); max-height: calc(100vh - 95px); overflow-y: scroll;"
    data-cy="historico-container"
  >
    <b-container class="p-4 p-md-5" data-cy="historico-inner-container">
      <b-row data-cy="historico-row-header">
        <b-col cols="12" data-cy="historico-col-header">
          <h4 class="text-primary font-weight-bold" data-cy="historico-title">
            Histórico
          </h4>
          <small class="font-weight-bold" data-cy="historico-subtitle"
            >Confira abaixo o histórico de seus agendamentos</small
          >
        </b-col>
        <b-col
          cols="12"
          class="text-center"
          v-if="!loading && historyPage.content.length === 0"
          data-cy="historico-col-empty"
        >
          <h4 class="alert-heading mt-5" data-cy="historico-empty-msg">
            Não há agendamentos disponíveis
          </h4>
        </b-col>

        <div class="col-12" data-cy="historico-col-spinner">
          <div
            class="m-5 text-center text-primary"
            v-if="loading"
            data-cy="historico-spinner"
          >
            <font-awesome-icon
              spin
              size="10x"
              :icon="['fas', 'circle-notch']"
              data-cy="historico-spinner-icon"
            ></font-awesome-icon>
          </div>
        </div>

        <b-col
          cols="12"
          class="mt-3"
          v-for="history in historyPage.content"
          :key="history.id"
          :data-cy="`historico-item-${history.id}`"
        >
          <historico-card
            :history="history"
            data-cy="historico-card"
          ></historico-card>
        </b-col>
      </b-row>
      <b-row class="bg-white mt-3" data-cy="historico-row-pagination">
        <b-col cols="12" data-cy="historico-col-pagination">
          <b-pagination-nav
            v-if="historyPage.content.length !== 0"
            align="center"
            :base-url="'?page='"
            :number-of-pages="historyPage.totalPages"
            use-router
            data-cy="historico-pagination-nav"
          ></b-pagination-nav>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
import HistoricoCard from "@/components/historico-card.vue";

export default {
  name: "historico",
  components: { HistoricoCard },
  data() {
    return {
      loading: true
    };
  },
  watch: {
    $route() {
      this.loadhistory();
    }
  },
  created() {
    this.loadhistory();
  },
  methods: {
    loadhistory() {
      this.loading = true;
      let payload = {
        url: this.$serverHost,
        page: this.$route.query.page
      };

      this.$store
        .dispatch("load_history", payload)
        .finally(() => (this.loading = false));
    }
  },
  computed: {
    historyPage() {
      return this.$store.getters.historyPage || { content: [] };
    }
  }
};
</script>

<style></style>
